import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/svg/marketing-top-circle.svg?data'
import _imports_1 from '@/assets/images/svg/marketing-middle-circle.svg?data'
import _imports_2 from '@/assets/images/svg/marketing-bottom-circle.svg?data'


const _hoisted_1 = { class: "app-marketing" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "marketing__circle-top",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "marketing__circle-middle",
  src: _imports_1
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "marketing__circle-bottom",
  src: _imports_2
}, null, -1)
const _hoisted_5 = { class: "flex-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "marketing__slider-title" }
const _hoisted_8 = { class: "marketing__slider-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSlider = _resolveComponent("AppSlider")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_AppSlider, {
      sliderData: _ctx.MARKETING_DATA,
      displaySliderButtons: false,
      slidesPerView: 1,
      pagination: { 'clickable': true },
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }
    }, {
      default: _withCtx((props) => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: props.slide.src
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(props.slide.title), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(props.slide.description), 1)
      ]),
      _: 1
    }, 8, ["sliderData"])
  ]))
}